import React from 'react';
import styles from './menu-separator.scss';

export const MenuSeparator = () => <div className={styles.container} />;
